import {Component, OnInit} from '@angular/core';
import {WebNavigationService} from '../../../navigation.service';
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-conciliacion-submenu',
  templateUrl: './conciliacion-submenu.component.html',
  styleUrls: ['./conciliacion-submenu.component.scss'],
})
export class ConciliacionSubmenuComponent implements OnInit {

  constructor(private navigationService: WebNavigationService, private router: Router, private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
  }

  selectConciliacionOption(conciliacionOption) {
    this.navigationService.selectConciliacionOption(conciliacionOption);
    this.router.navigate(['conciliacion'], {relativeTo: this.activatedRoute});
  }

  get selectedOption() {
    return this.navigationService.selectedOption;
  }

  get expanded() {
    return this.navigationService.expanded;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/navigation/options/conciliacion/conciliacion-submenu/conciliacion-submenu.component.ts